module.exports = __webpack_public_path__ + "static/img/travel.4021048f.png";